import store from '@/store'
import Cookies from 'js-cookie'
const TokenKey = 'Admin-Token'
// const userId = 'userId'
const userId = '_id_'
const userName = 'userName'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getUserId() {
    return localStorage.getItem(userId)
}

export function setUserId(id) {
    store.commit("setUserId", id);
    localStorage.setItem(userId, id)
}

export function removeUserId() {
    store.commit("setUserId", undefined);
    localStorage.removeItem(userId)
}

export function getUserName() {
    return localStorage.getItem(userName)
}

export function setUserName(name) {
    store.commit("user/SET_ACCOUNT", name);
    localStorage.setItem(userName, name)
}

export function removeUserName() {
    store.commit("user/SET_ACCOUNT", undefined);
    localStorage.removeItem(userName)
}

export function setOrganization(organization) {
    localStorage.setItem('organization', JSON.stringify(organization))
    store.commit('setState', {
        key: 'organization',
        value: organization
    })
}

export function getOrganization() {
    let organization = localStorage.getItem('organization')
    if (organization) {
        organization = JSON.parse(organization)
    }
    return organization
}

export function getLogo() {
    let logo, organization = getOrganization()
    if (organization) {
        logo = organization.imagePath
    }
    return logo
}

/* 获取地面站设置 */
export function getBaseConfig() {
    let config
    const groundStationConfig = localStorage.getItem('groundStationConfig')
    if (groundStationConfig) {
        config = JSON.parse(groundStationConfig)
    }
    return config
}
